import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class BringToFrontMessage extends WebViewMessage {
  public constructor() {
    super(MessageType.BringToFront);
  }
}
